import {
  ButtonGroup,
  Card, IconButton,
  LinearProgress, Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import TableHeadCell from '../../../general/TableHeadCell';
import React, { useEffect, useState } from 'react';
import TableNavigation from '../../../general/TableNavigation';
import MainAuthorsSearch from './MainAuthorsSearch';
import { listMainAuthors } from '../../../../services/main_author';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const MainAuthorsList = ({ userStore }) => {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState({
    total_pages: 1,
    total: 1,
    limit: 10,
    current_page: 1
  });
  const [order, setOrder] = useState('id');
  const [sort, setSort] = useState('asc');
  const [filters, setFilters] = useState({});

  const handleOrder = (field) => {
    setCurrentPage(1);
    setOrder(field);
    setSort(paginationData.ordered_by !== field ? 'asc' : (paginationData.sorted === 'asc' ? 'desc' : 'asc'));
  };

  const loadAuthors = async () => {
    setLoading(true);
    try {
      const response = await listMainAuthors(currentPage, filters, order, sort, userStore.token);
      if (response.data?.data) {
        setPaginationData(response.data.data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAuthors();
  }, [currentPage, order, sort, filters]);

  return (
    <div>
      <MainAuthorsSearch loading={loading}
                         handleSubmit={filters => {
                           setCurrentPage(1);
                           setFilters(filters);
                         }}
                         clear={() => {
                           setCurrentPage(1);
                           setFilters({});
                         }}
      />
      <br />
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell field='id' title='ID' paginationData={paginationData} handleOrder={handleOrder} />
                <TableHeadCell field='name' title='Nome do Autor' paginationData={paginationData}
                               handleOrder={handleOrder} />
                <TableHeadCell field='books_count' title='Qtd. de livros-pai vinculados'
                               paginationData={paginationData} handleOrder={handleOrder} />
                <TableHeadCell field='quotes_count' title='Qtd. de trechos vinculados'
                               paginationData={paginationData} handleOrder={handleOrder} />
                <TableCell>Status de preenchimento</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (<TableRow><TableCell colSpan={6}><LinearProgress /></TableCell></TableRow>) : (paginationData?.data?.map((data) => {
                return <TableRow>
                  <TableCell style={{ width: '40px' }}>{data.id}</TableCell>
                  <TableCell>{data.name}</TableCell>
                  <TableCell>{data.books_count}</TableCell>
                  <TableCell>{data.quotes_count}</TableCell>
                  <TableCell>{data.status == 'filled' ? 'Preenchido' : 'Antigos'}</TableCell>
                  <TableCell style={{ width: '110px' }}>
                    <ButtonGroup>
                      <Link
                        href={`/app/main/authors/${data.id}`}>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </Link>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              }))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableNavigation
          totalPages={paginationData.total_pages}
          totalItens={paginationData.total}
          itensPerPage={paginationData.limit}
          currentPage={paginationData.current_page}
          onPageChange={async (page) => {
            setCurrentPage(page);
          }}
        />
      </Card>
    </div>
  );
};

export default MainAuthorsList;
